export default function(change) {
    if (change > 0) {
        return "#icon-arrow-up";
    } else {
        return "#icon-arrow-down";
    }
}



// WEBPACK FOOTER //
// ./src/js/utilities/get-svg-arrow-name.js